export const CREATE_LINK = "https://linkseva.onrender.com/api/link/";
export const GET_LINK = "https://linkseva.onrender.com/api/link/";
